import React from "react";
import { graphql } from "gatsby";
import { Col, Container, Row } from "react-bootstrap";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import AnchorID from "../../atoms/AnchorID";
import { getParagraph } from "../../../utils/paragraphHelpers";
import "./paraDownloads.scss";
import ExtractRichText from "../../molecules/ExtractRichText";

export const ParagraphDownloads = ({ node }) => {
  const paragraphs = node?.relationships?.field_cta_link?.map(getParagraph);

  return (
    <div className="downloads">
      <AnchorID id={node?.field_section_id} />
      <Container className="general-container" data-aos="fade-up">
        <Row>
          {node?.field_component_title && (
            <h2
              data-aos="underlined"
              className="underlined underlined-bg-regalBlue downloads__title"
            >
              {node?.field_component_title}
            </h2>
          )}
        </Row>
        <Row className="d-flex align-items-center">
          <Col xs={12} md={5}>
            <GatsbyImage
              className="downloads__cover-img"
              image={getImage(
                node?.relationships?.field_card_image?.relationships
                  ?.field_media_image
              )}
            />
          </Col>

          <Col xs={12} md={6}>
            {node?.field_heading && (
              <h3 className="downloads__subtitle">{node?.field_heading}</h3>
            )}
            {paragraphs && paragraphs?.length > 0 && (
              <div className="cta-wrapper">{paragraphs}</div>
            )}

            {node?.field_body_text?.value && (
              <div className="mt-5">
                <ExtractRichText richText={node?.field_body_text?.value} />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphDownloads on paragraph__downloads_cta_lp {
    field_component_title
    field_heading
    field_section_id
    field_body_text {
      value
    }
    relationships {
      field_cta_link {
        type: __typename
        ...ParagraphLinks
      }
      field_card_image {
        relationships {
          field_media_image {
            gatsbyImage(width: 400, quality: 100, placeholder: BLURRED)
          }
        }
      }
    }
  }
`;
